import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import Loader from '../../../component/Loader/Loader';
import MappingModbusTable from './MappingModbusTable';
import Breadcrumb from '../../../component/Breadcrumb';
import ModbusAddModal from '../../ModBus/ModbusAddModal';
import MappingTabing from '../../../component/MappingTabing';
import { Box, Button, Grid, Typography } from '@mui/material';
import { fetchAutoCompleteSheetData, getDataForExistingAddresses } from '../../../api/mappingApi';
import { modbusOptions } from '../../../constants';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';


const MappingModbus = () => {
    const [itemForLocal, setItemForLocal]         = useState(false);
    const inputRef                                = useRef(null);
    const [open, setOpen]                         = useState(false);
    const [rowIndex, setRowIndex]                 = useState('');
    const [showLoader, setShowLoader]             = useState('');
    const [modbusTableData, setModbusTableData]   = useState([]);
    const [sheetMappingData, setSheetMappingData] = useState([]);
    const [sheetFilter, setSheetFilter]           = useState('');
    const [searchValue, setSearchValue]           = useState('');
    const [lengthCount, setLengthCount]           = useState(0);
    const [autoCompleteLoading, setAutoCompleteLoading] = useState(false);
    const [fieldsModal, setFieldsModal] = useState({
        RegAddr        :    '',
        Sheet          :    '',
        Addr           :    '',
        DataType       :    '',
        EnglishText    :    '',
    });

    const handleClickOpen = () => {
        setOpen(true);
    };
  
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const dataInLocalStorage = checklocalStorageItems();
        setItemForLocal(dataInLocalStorage);
        fetchModbusData();
        window.addEventListener('storage',fetchModbusData);
        return () => {
            window.removeEventListener('storage',fetchModbusData);
        }
    },[lengthCount]);

    const fetchModbusData = async () => {
        let existingModbus= JSON.parse(localStorage.getItem('Modbus'));
        if(existingModbus != null && existingModbus.length > 0){
            setLengthCount(existingModbus.length);
            //if(existingModbus.length !== lengthCount){
                const formData = new FormData();
                const jsonData = JSON.stringify(existingModbus);
                formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt');
                setShowLoader(true);
                let fetchDataForExisiting = await getDataForExistingAddresses(formData);
                setShowLoader(false);
                if(fetchDataForExisiting){
                    setModbusTableData(fetchDataForExisiting);
                }
           // }
        }
    }

    useEffect(() => {
        if(!open){
            setFieldsModal({
                RegAddr        :    '',
                Sheet          :    '',
                Addr           :    '',
                DataType       :    '',
                EnglishText    :    '',
            });
            setRowIndex('');
            setSheetFilter('');
            setSheetMappingData([]);
        }        
    },[open])

    const handleRowEdit = (index,item) => {  
        setFieldsModal((prevState) =>  ({...prevState, 'RegAddr': item.RegAddr }));
        setRowIndex(index);
        setOpen(true);
    }

    const handleAddModalFormData = () => {
        let error = (fieldsModal.RegAddr === '' ||  fieldsModal.Sheet === '' || fieldsModal.Addr === '') ? true : false;
        if(error){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }

        if((fieldsModal.RegAddr >= 1 && fieldsModal.RegAddr <= 9999) && (fieldsModal.DataType.toLowerCase() !== 'boolean' && fieldsModal.DataType !== 'YesNoBoolean' && fieldsModal.DataType !== 'ActiveInactiveBoolean' &&  fieldsModal.DataType !== 'OnOffBoolean')){
            swal("Oops!", "Incorrect DataType selected for the Range. Please select address with Boolean Datatype.", "error");
            return false;
        }

        if((fieldsModal.RegAddr >= 40001 && fieldsModal.RegAddr <= 49999) && (fieldsModal.DataType === 'Boolean' || fieldsModal.DataType === 'YesNoBoolean' || fieldsModal.DataType === 'ActiveInactiveBoolean' || fieldsModal.DataType === 'OnOffBoolean')){
            swal("Oops!", "Incorrect DataType selected for the Range. Please select address without Boolean Datatype.", "error");
            return false;
        }

        let duplicateRegAddr;
        if(rowIndex !== ''){
            duplicateRegAddr =  modbusTableData.some((val,k) => val.RegAddr == fieldsModal.RegAddr && k != rowIndex  ? true : false);
        } else {
            duplicateRegAddr =  modbusTableData.some(val => val.RegAddr == fieldsModal.RegAddr ? true : false);
        }
        if(duplicateRegAddr){
            swal("Oops!", "Modbus Address is already used. Please select different Modbus Address.", "error");
            return false;
        }
        let duplicateAddr;
        if(rowIndex !== ''){
            duplicateAddr =  modbusTableData.some((val,k) => val.Addr == fieldsModal.Addr && k != rowIndex  ? true : false);
        } else {
            duplicateAddr =  modbusTableData.some(val => val.Addr == fieldsModal.Addr ? true : false);
        }
        if(duplicateAddr){
            swal("Oops!", "Address is already used. Please select different Address.", "error");
            return false;
        }
        let existingModbus= JSON.parse(localStorage.getItem('Modbus'));
        if(existingModbus != null && existingModbus.length > 0){
            if(rowIndex !== ''){
                let existingArray = [...existingModbus];
                existingArray[rowIndex] = {"RegAddr": parseInt(fieldsModal.RegAddr),"Addr": fieldsModal.Addr};
                localStorage.setItem('Modbus',JSON.stringify(existingArray));
            } else {
                const newValueArray = [...existingModbus, {"RegAddr": parseInt(fieldsModal.RegAddr),"Addr": fieldsModal.Addr}];
                localStorage.setItem('Modbus',JSON.stringify(newValueArray));
            }
        } else {
            localStorage.setItem('Modbus',JSON.stringify([{"RegAddr": parseInt(fieldsModal.RegAddr),"Addr": fieldsModal.Addr}]));
        }
        fetchModbusData();
        setOpen(false);
    }



    useEffect(() => {
        const fetchAutoCompleteData = () => {
            if(searchValue === ''){
                setSheetMappingData([]);
                return;
            }
            let active;
            if(sheetFilter && fieldsModal.RegAddr !== ''){
                active = true;
                ( async () => {
                        setAutoCompleteLoading(true);
                        const data = await fetchAutoCompleteSheetData(fieldsModal.RegAddr,sheetFilter,searchValue);
                        if(active){
                            setSheetMappingData(data);
                            setAutoCompleteLoading(false);
                        }
                    }
                )();
            }
            return () => {
                active = false;
            }
        };
        fetchAutoCompleteData();
    },[sheetFilter,searchValue,fieldsModal.RegAddr])

    const handleChangeAutoComplete = (values) => {
        if(values) {
            Object?.keys(values)?.map(val => {
                let key = val === 'Address' ? 'Addr' : val;
                return setFieldsModal((prevState) =>  ({...prevState, [key]: values[val] }))
            })
        }
    }

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value);
    }

    const changeHandler = (name,value) => {
        if(name === 'Sheet'){
            setSheetFilter(value)
        }
        setFieldsModal((prevState) =>  ({...prevState, [name]: value }));
    };

    const handleRowDelete = (index) => {
        const newArray = [...modbusTableData];
        newArray.splice(index, 1);
        setModbusTableData(newArray);
        if(newArray.length === 0){
            localStorage.removeItem("Modbus");
        } else {
            localStorage.setItem('Modbus',JSON.stringify(newArray));
        }
    };

    const handleConfigFileContent = async() => {
        setShowLoader(true);
        const result = await saveContentFile();
        setShowLoader(false);
        if(result){
            swal({
              title: "Success",
              text: result.message,
              icon: "success",
            })
        }
    }

   
    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="Configuration Modbus">
                <Typography component={Link} to="/" variant="subtitle2" color="primary"  className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                Modbus
                </Typography>
            </Breadcrumb>
            <MappingTabing 
                value="modbus" 
                handleConfigFileContent={handleConfigFileContent}
            />
            <Box  component="section">
                <Grid className="contentBox">
                    {itemForLocal &&
                        <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                            <Grid item>
                                <Button
                                    onClick={handleClickOpen}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    sx={{mr:3}}
                                >Add New 
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    {modbusTableData.length === 0  &&
                        <p>No Data Available.</p>
                    }
                    <MappingModbusTable 
                        data={modbusTableData}
                        handleRowEdit={handleRowEdit}
                        handleRowDelete={handleRowDelete}
                    />
                </Grid>
            </Box>
            <ModbusAddModal
                open={open}
                rowIndex={rowIndex}
                inputRef={inputRef}
                fields={fieldsModal} 
                onClose={handleClose}
                modbusOptions={modbusOptions}
                changeHandler={changeHandler} 
                autoCompleteOptions={sheetMappingData}
                autoCompleteLoading={autoCompleteLoading}
                handleAddModalFormData={handleAddModalFormData}
                handleChangeAutoComplete={handleChangeAutoComplete}
                handleSearchValueAutoComplete={handleSearchValueAutoComplete}
            /> 
        </>
    )
}

export default MappingModbus